import type { Stage } from '../api/client';

interface CognitoConfig {
  userPoolId: string;
  userPoolClientId: string;
  domain: string;
  redirectSignIn: string;
  redirectSignOut: string;
}

const cognitoConfigs: Record<Stage, CognitoConfig> = {
   dev: {
    userPoolId: 'us-west-1_dwCjmKqqk',
    userPoolClientId: 'nsdgbemg21ss7mhc2d667926r',
    domain: 'keystoneiam-alpha.auth.us-west-1.amazoncognito.com',
    redirectSignIn: 'http://localhost:4321/',
    redirectSignOut: 'http://localhost:4321/',
  },
  alpha: {
    userPoolId: 'us-west-1_dwCjmKqqk',
    userPoolClientId: 'nsdgbemg21ss7mhc2d667926r',
    domain: 'keystoneiam-alpha.auth.us-west-1.amazoncognito.com',
    redirectSignIn: 'https://alpha.console.keystone.device.finance.amazon.dev/',
    redirectSignOut: 'https://alpha.console.keystone.device.finance.amazon.dev/',
  },
  beta: {
    userPoolId: 'us-west-1_PXABGCCXO',
    userPoolClientId: '3mup57bdfg8hgdl7r84f4hsn9q',
    domain: 'keystoneiam-beta.auth.us-west-1.amazoncognito.com',    
    redirectSignIn: 'https://beta.console.keystone.device.finance.amazon.dev/',
    redirectSignOut: 'https://beta.console.keystone.device.finance.amazon.dev/',
  },
  gamma: {
    userPoolId: 'us-west-1_nk9TipGKN',
    userPoolClientId: '1cqc5rr368kssrvbv8esl6bujs',
    domain: 'keystoneiam-gamma.auth.us-west-1.amazoncognito.com',
    redirectSignIn: 'https://gamma.console.keystone.device.finance.amazon.dev/',
    redirectSignOut: 'https://gamma.console.keystone.device.finance.amazon.dev/',
  },
  prod: {
    userPoolId: 'us-west-1_weJu1u9Ic',
    userPoolClientId: '1fhr20n644c4rqi81v3buktf3d',
    domain: 'keystoneiam-prod.auth.us-west-1.amazoncognito.com',
    redirectSignIn: 'https://console.keystone.device.finance.amazon.dev/',
    redirectSignOut: 'https://console.keystone.device.finance.amazon.dev/',
  },
};

export function getCognitoConfig(stage: Stage): CognitoConfig {
  return cognitoConfigs[stage];
}

export function getAmplifyConfig(stage: Stage) {
  const config = getCognitoConfig(stage);
  return {
    Auth: {
      Cognito: {
        userPoolId: config.userPoolId,
        userPoolClientId: config.userPoolClientId,
        loginWith: {
          oauth: {
            domain: config.domain,
            scopes: ['openid', 'email', 'profile'],
            redirectSignIn: [config.redirectSignIn],
            redirectSignOut: [config.redirectSignOut],
            responseType: 'code' as const,
          },
        },
      },
    },
  };
}
